import { gql } from "@apollo/client";


export const GET_SYSTEM_NOTICES = gql`
query SystemNotices($orderBy: OrderByInput, $skip: Int, $limit: Int, $where: SystemNoticeWhereInput) {
  systemNotices(orderBy: $orderBy, skip: $skip, limit: $limit, where: $where) {
    total
    totalNotice
    data {
      id
      title
      link
      details {
        title
        images
      }
      images
      status
      creatorName
      updatorName
      createdAt
      updatedAt
    }
  }
}
`

 
export const GET_READ_SYSTEM_NOTICES = gql`
query ReadSystemNotices($where: SystemNoticeWhereInput, $skip: Int, $limit: Int, $orderBy: OrderByInput) {
  readSystemNotices(where: $where, skip: $skip, limit: $limit, orderBy: $orderBy) {
    data {
      id
      shop
      systemNotice
      createdAt
      updatedAt
    }
    total
  }
}
`


